import {
  Button,
  Col,
  Flex,
  Image,
  Modal,
  Row,
  Tag,
  Typography,
  Upload,
} from "antd";
import React, { useEffect, useState } from "react";
import styles from "./CustomerInfo.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerInfoByIdAction } from "../../../../../../redux/services/customers/customersServices";
import RequiredLabel from "../../../../../common/required-label/RequiredLabel";
import {
  dateObjToDispViewDate,
  downloadUrl,
  formulateAttachmentPreview,
  readImageFileAsync,
} from "../../../../../../utils/utils";
import { routes } from "../../../../../../constants";
import { baseRouteMakerForSuperAdmin } from "../../../../../../constants/routeConsts";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import {useTranslation} from "react-i18next";
import { colors } from "../../../../../../constants/colors";
import { StatusTag } from "../../../../../common/status-tag";

const CustomerInfoDetailsDetails = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);

  const { selectedCustomerId } = useSelector((state) => state.customers);
  const [customerInfoDetails, setCustomerInfoDetails] = useState(null);

  /* module dependencies for attachment */
  const [openPreviewDialog, setOpenPreviewDialog] = useState(false);
  const [previewImageSrc, setPreviewImageSrc] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [attachmentList, setAttachmentList] = useState([]);
  /* module dependencies for attachment */

  useEffect(() => {
    /* initial dependencies - Edit */
    if (
      selectedCustomerId &&
      selectedCustomerId !== "" &&
      selectedCustomerId !== null &&
      selectedCustomerId !== undefined
    ) {
      const dataToBeSent = {
        selectedCustomerId,
      };
      dispatch(getCustomerInfoByIdAction(dataToBeSent, setLoading)).then(
        (apiRes) => {
          const response = apiRes;
          setCustomerInfoDetails(response);
          let temp_photo_id_proof = "";
          if (
            response?.photo_id_proof &&
            response?.photo_id_proof !== null &&
            response?.photo_id_proof !== undefined
          ) {
            temp_photo_id_proof = response?.photo_id_proof;
            setAttachmentList([{ name: "", url: temp_photo_id_proof }]);
          } else {
            setAttachmentList([]);
          }
        }
      );
    }
  }, []);

  /* open image preview for dialog - multiple attachment */
  const handleAttachmentPreview = async (file) => {
    const formulateAttachment = await formulateAttachmentPreview(
      file,
      file?.name,
      file.url
    );
    if (!formulateAttachment?.isFileTypeImage) {
      downloadUrl(formulateAttachment?.fileImagePreview);
    } else {
      if (!file.url && !file.preview) {
        file.preview = await readImageFileAsync(file.originFileObj);
      }
      setPreviewImageSrc(file?.url || file?.preview);
      setOpenPreviewDialog(true);
      const tempPreviewTitle =
        file?.name || file?.url?.substring(file?.url?.lastIndexOf("/") + 1);
      setPreviewTitle(tempPreviewTitle);
    }
  };
  /* open image preview for dialog - multiple attachment */

  return (
    <div className={styles.customerInfoDetailsContainer}>
      <Flex vertical gap="2rem">
        <Flex gap="1rem">
          <Button
            type="default"
            shape="circle"
            size="small"
            icon={<ArrowLeftOutlined />}
            onClick={() =>
              navigate(baseRouteMakerForSuperAdmin(routes.CUSTOMER_INFO))
            }
          />
          <Typography.Title underline level={2}>
            {t("CommonUtils.customerInfo")}
          </Typography.Title>
        </Flex>
        <Row gutter={[16, 16]}>
          <Col span={8}>
            <RequiredLabel
              text={t("CommonUtils.profileImage")}
              required={false}
            />
            {customerInfoDetails?.profile_image ? (
              <Image
                style={{
                  width: "120px",
                  maxWidth: "100%",
                  border: "1px solid lightGray",
                  padding: "5px",
                  borderRadius: "10px",
                }}
                src={customerInfoDetails?.profile_image ?? "-"}
                alt={t("CommonUtils.profileImage")}
              />
            ) : (
              <>-</>
            )}
          </Col>
          <Col span={8}>
            <RequiredLabel text={t("CommonUtils.fullName")} required={false} />
            <div>{`${
              customerInfoDetails?.first_name || customerInfoDetails?.last_name
                ? customerInfoDetails?.first_name +
                  " " +
                  customerInfoDetails?.last_name
                : "-"
            }`}</div>
          </Col>
          <Col span={8}>
            <RequiredLabel text={t("CommonUtils.email")} required={false} />
            <div>{customerInfoDetails?.email ?? "-"}</div>
          </Col>
          <Col span={8}>
            <RequiredLabel
              text={t("CommonUtils.phoneNumber")}
              required={false}
            />
            <div>{`${
              customerInfoDetails?.phone?.country_code &&
              customerInfoDetails?.phone?.phone_number
                ? "+" +
                  customerInfoDetails?.phone?.country_code +
                  " " +
                  customerInfoDetails?.phone?.phone_number
                : "-"
            }`}</div>
          </Col>
          <Col span={8}>
            <RequiredLabel text={t("ProfileSetup.countryLabel")} required={false} />
            <div>{customerInfoDetails?.country?.name || "-"}</div>
          </Col>
          <Col span={8}>
            <RequiredLabel text={t("CommonUtils.city")} required={false} />
            <div>{customerInfoDetails?.address?.city?.name || "-"}</div>
          </Col>
          <Col span={8}>
            <RequiredLabel text={t("CommonUtils.state")} required={false} />
            <div>{customerInfoDetails?.address?.state?.name || "-"}</div>
          </Col>
          <Col span={8}>
            <RequiredLabel text={t("CommonUtils.zipCode")} required={false} />
            <div>{customerInfoDetails?.address?.zip_code || "-"}</div>
          </Col>
          <Col span={8}>
            <RequiredLabel text={t("CommonUtils.gender")} required={false} />
            <div>{customerInfoDetails?.gender || "-"}</div>
          </Col>
          <Col span={8}>
            <RequiredLabel
              text={t("CommonUtils.dateOfBirth")}
              required={false}
            />
            <div>
              {customerInfoDetails?.date_of_birth ? dateObjToDispViewDate(
                    customerInfoDetails?.date_of_birth,
                    "ddmmyyyy"
                  )
                : "-"}
            </div>
          </Col>
          <Col span={8}>
            <RequiredLabel text={t("CommonUtils.weight")} required={false} />
            <div>{customerInfoDetails?.weight ? `${customerInfoDetails?.weight?.number ?? ""} ${
              customerInfoDetails?.weight?.unit ?? ""
            }` : "-"}</div>
          </Col>
          <Col span={8}>
            <RequiredLabel text={t("CommonUtils.height")} required={false} />
            <div>{customerInfoDetails?.height ? `${customerInfoDetails?.height?.number ?? ""} ${
              customerInfoDetails?.height?.unit ?? ""
            }` : "-"}</div>
          </Col>

          <Col span={8}>
            <RequiredLabel
              text={t("CommonUtils.walletBalance")}
              required={false}
            />
            <div>{customerInfoDetails?.wallet_balance?.toFixed(2) ?? "-"}</div>
          </Col>
          <Col span={8}>
            <RequiredLabel
              text={t("CommonUtils.accountStatus")}
              required={false}
            />
            <StatusTag status={customerInfoDetails?.status === "active" ? true : false}/>
          </Col>

          <Col span={24}>
            <RequiredLabel
              text={t("CommonUtils.photoIDProof")}
              required={false}
            />
            {attachmentList?.length !== 0 ? (
              <Flex vertical align="center" justify="center">
                <Upload
                  listType="picture-card"
                  fileList={attachmentList.filter(
                    (element) => element.url !== ""
                  )}
                  accept="image/*"
                  onPreview={handleAttachmentPreview}
                  className="uploadContainer"
                ></Upload>
                <Modal
                  open={openPreviewDialog}
                  title={t("Modules.Appointments.previewTitle")}
                  footer={null}
                  onCancel={() => setOpenPreviewDialog(false)}
                >
                  <img style={{ width: "100%" }} src={previewImageSrc} />
                </Modal>
              </Flex>
            ) : (
              <>-</>
            )}
          </Col>
        </Row>
      </Flex>
    </div>
  );
};

export default CustomerInfoDetailsDetails;
